module.exports = __webpack_public_path__ + "img/mockup-fratelli.89416d8.png";